'use client'

import iconCopied from '@/assets/svg/icon_copied.svg'
import iconCopy from '@/assets/svg/icon_copy.svg'
import iconTg from '@/assets/svg/icon_tg.svg'
import iconVk from '@/assets/svg/icon_vk.svg'
import iconShare from '@/assets/svg/shareIcon.svg'
import Link from 'next/link'
import { useState } from 'react'

import { Icon } from '@/shared/ui/icon'
import { Popover } from '@/shared/ui/Popover'

import styles from './ShareButton.module.scss'

export const ShareButton = (): JSX.Element => {
	// State for copied link
	const [isOpen, setIsOpen] = useState<boolean>(false)

	// Url of current page
	const location = typeof window !== `undefined` ? window.location.href : ``

	// Copy to clipboard function
	const shareButtonHandler = async () => {
		await navigator.clipboard.writeText(location)
		setIsOpen(!isOpen)

		//reset in 10s
		setTimeout(setIsOpen, 10000)
	}

	//Popover content
	const hoverContent = (
		<div className={styles.list}>
			<div className={styles.item} onClick={shareButtonHandler}>
				{isOpen && (
					<>
						<Icon icon={iconCopied} aria-hidden="true" width={16} height={16} />
						<span>Ссылка скопирована</span>
					</>
				)}
				{!isOpen && (
					<>
						<Icon icon={iconCopy} aria-hidden="true" width={16} height={16} />
						Копировать ссылку
					</>
				)}
			</div>

			<div className={styles.item}>
				<Link prefetch={false} href={`https://vk.com/share.php?url=` + location} target="_blank">
					<Icon icon={iconVk} aria-hidden="true" width={16} height={16} />
					Вконтакте
				</Link>
			</div>

			<div className={styles.item}>
				<Link prefetch={false} target="_blank" href={`https://t.me/share/url?url=` + location}>
					<Icon icon={iconTg} aria-hidden="true" width={16} height={16} />
					Telegram
				</Link>
			</div>
		</div>
	)

	return (
		<div className={styles.shareButton}>
			<Popover placement="bottomRight" content={hoverContent} trigger="hover">
				<button className={styles.button}>
					<Icon icon={iconShare} aria-hidden="true" width={20} height={20} />
					<span>Поделиться</span>
				</button>
			</Popover>
		</div>
	)
}
